import { useEffect, useState } from "react";
import { getBasket } from "../utils/basketApi";
import { getBasketItems } from "../utils/getBasketItems";
import { SimplifiedBasketItem } from "../types";
import { ADD_TO_BASKET_ESI_CHILD_ITEMS_UPDATED_POST_A2B } from "@/constants/constants.ts";

export const useBasket = (basketApiBaseUrl: string, pimProductId: string) => {
  const [basket, setBasket] = useState<SimplifiedBasketItem[]>([]);

  useEffect(() => {
    const fetchBasket = async () => {
      const basketData = await getBasket(basketApiBaseUrl);

      if (basketData.errors?.length === 0 && basketData.basket?.commerceItems) {
        const basketItems = getBasketItems(
          basketData.basket.commerceItems,
          pimProductId,
        );
        setBasket(basketItems);
      }
    };

    fetchBasket();
  }, [basketApiBaseUrl, pimProductId]);

  useEffect(() => {
    const handleBasketUpdate = async () => {
      const basketData = await getBasket(basketApiBaseUrl);

      if (basketData.errors?.length === 0 && basketData.basket?.commerceItems) {
        const basketItems = getBasketItems(
          basketData.basket.commerceItems,
          pimProductId,
        );
        setBasket(basketItems);
      }
    };

    window.addEventListener(
      ADD_TO_BASKET_ESI_CHILD_ITEMS_UPDATED_POST_A2B,
      handleBasketUpdate,
    );

    return () => {
      window.removeEventListener(
        ADD_TO_BASKET_ESI_CHILD_ITEMS_UPDATED_POST_A2B,
        handleBasketUpdate,
      );
    };
  }, [basketApiBaseUrl, pimProductId]);

  return { basket, setBasket };
};
